import {$$} from '@vue-macros/reactivity-transform/macros'

import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'

import {
  IRatingPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/RatingPropertyTypeStrategy/types/IRatingPropertyTypeInterfaces'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {DatabaseViewType} from '@toolify/server/src/models/mongoose/DatabaseViewModel/enum/DatabaseViewType'
import {GroupSortModeType} from '@toolify/server/src/services/DatabasePropertyService/enum/GroupSortModeType'
import {COMMON_GROUP_SORT_LABEL_KEYS} from '@toolify/client/src/modules/databases/utils/groupSortModes'

export function useRatingValueTypeStrategy() {

  const fullValueToText = (value: IRatingPropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance) => {
    return String(value || '')
  }

  const searchToFilterQuery = (search: string, databaseProperties: IDatabasePropertyResponseInstance[]): IFilter => {
    return {
      type: FilterItemType.Group,
      operator: FilterGroupOperator.Or,
      items: databaseProperties.map(databaseProperty => {
        return {
          type: FilterItemType.Property,
          id: databaseProperty.id,
          subProperty: null,
          operator: {
            type: FilterPropertyOperator.Contains,
          },
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: search,
          },
          isDisabled: false,
        }
      }),
    }
  }

  const canGroupByView = (viewType: DatabaseViewType, _property: IDatabasePropertyResponseInstance) =>
    viewType === DatabaseViewType.Table || viewType === DatabaseViewType.Kanban

  const compareItemValues = (
    valueA: IRatingPropertyTypeInterfaces['fullValue'],
    valueB: IRatingPropertyTypeInterfaces['fullValue'],
    sortDirection: '1' | '-1',
  ): number => {
    const hasValueA = valueA !== null && valueA !== undefined
    const hasValueB = valueB !== null && valueB !== undefined
    if (!hasValueA && !hasValueB) return 0
    if (!hasValueA) return 1
    if (!hasValueB) return -1
    const comparison = Number(valueA) - Number(valueB)
    return sortDirection === '1' ? comparison : -comparison
  }

  const groupSort = {
    availableModes: [GroupSortModeType.ValueAsc, GroupSortModeType.ValueDesc, GroupSortModeType.CountDesc, GroupSortModeType.CountAsc],
    defaultMode: GroupSortModeType.ValueAsc,
    getLabelKey: (mode: GroupSortModeType): string => {
      if(mode === GroupSortModeType.ValueAsc) return 'database.header.groupSort.numericAsc'
      if(mode === GroupSortModeType.ValueDesc) return 'database.header.groupSort.numericDesc'
      return COMMON_GROUP_SORT_LABEL_KEYS[mode]
    },
  }

  return $$({
    fullValueToText,
    searchToFilterQuery,
    canGroupByView,
    compareItemValues,
    groupSort,
  })
}
